import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatHeader = ({ onClose, isConnected = true, isMobile = false }) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-border bg-card">
      <div className="flex items-center space-x-3">
        {/* Dai Avatar with Lion/Crown Icon */}
        <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center relative">
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-primary-foreground">
            <path 
              fill="currentColor" 
              d="M12 2L3.09 8.26L4 21L12 17L20 21L20.91 8.26L12 2Z"
            />
            <circle cx="12" cy="10" r="2" fill="var(--color-secondary)" />
          </svg>
          {/* Connection Status Indicator */}
          <div className={`absolute -bottom-1 -right-1 w-3 h-3 rounded-full border-2 border-card ${
            isConnected ? 'bg-success' : 'bg-muted'
          }`} />
        </div>
        
        <div>
          <h3 className="font-heading font-semibold text-card-foreground">Mentor Dai</h3>
          <p className="text-sm text-muted-foreground font-caption flex items-center space-x-1">
            <div className={`w-2 h-2 rounded-full ${isConnected ? 'bg-success' : 'bg-muted'}`} />
            <span>{isConnected ? 'Online' : 'Conectando...'}</span>
          </p>
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        {/* Additional Actions for Desktop */}
        {!isMobile && (
          <>
            <Button
              variant="ghost"
              iconName="MoreVertical"
              iconSize={18}
              className="p-2"
              title="Mais opções"
            />
          </>
        )}
        
        <Button
          variant="ghost"
          onClick={onClose}
          iconName={isMobile ? "X" : "Minus"}
          iconSize={18}
          className="p-2"
          title={isMobile ? "Fechar" : "Minimizar"}
        />
      </div>
    </div>
  );
};

export default ChatHeader;